module.exports = __webpack_public_path__ + "../assets/dist/img/darkroom-burn-2.6ad1c8fe.png";